<template>

    <div id="skills_tab" class="flex_content" v-if="currentEval.saven_test">

        <div class="matching_bar_container" :class="matchingRange" v-if="dimensionsPlan.soft_skills_settings.ui_show_matching">
            <div class="matching_bar container" >
                <div class="matching_label_container">
                    <div class="matching_title">Total match</div>
                </div>
                <div class="matching_container">
                    <div class="matching_number" >
                        <animated-number :value="matching" :formatValue="formatValue" :duration="800" />%
                    </div>
                </div>

                <div class="fiability_container" >
                    <div class="fiability_label">{{ $t('modules.evaluations.edit.fiabilityScore') }}</div>
                    <div class="fiability_score">
                        <i class="zmdi zmdi-star" :class="{active: starIsChecked(1)}"></i>
                        <i class="zmdi zmdi-star" :class="{active: starIsChecked(2)}"></i>
                        <i class="zmdi zmdi-star" :class="{active: starIsChecked(3)}"></i>
                        <i class="zmdi zmdi-star" :class="{active: starIsChecked(4)}"></i>
                        <i class="zmdi zmdi-star" :class="{active: starIsChecked(5)}"></i>
                    </div>
                </div>
            </div>
        </div>

        <div class="radial_scores_line" v-if="dimensionsPlan.soft_skills_settings.ui_show_extra_scores">
            <div class="container ">
                <div class="radial_scores_container">

                    <div class="radial_score fid_score">
                        <div class="radial_label">{{ $t('modules.evaluations.edit.loyaltyScore') }}</div>
                        <div class="radial_chart">
                            <sightRadialProgress :value="currentEval.saven_test.loyalty_percent"></sightRadialProgress>
                        </div>
                    </div>
                    <div class="radial_score fid_score">
                        <div class="radial_label">{{ $t('modules.evaluations.edit.culturalScore') }}</div>
                        <div class="radial_chart">
                            <sightRadialProgress :value="currentEval.saven_test.cultural_adequacy_score"></sightRadialProgress>
                        </div>
                    </div>
                    <div class="radial_score fid_score">
                        <div class="radial_label">{{ $t('modules.evaluations.edit.evolutionScore') }}</div>
                        <div class="radial_chart">
                            <sightRadialProgress :value="currentEval.saven_test.evolution_percent"></sightRadialProgress>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="skills_scores_panel_container ">

            <div class="skills_with_title_container container">
                <div class="skills_title_bloc" v-for="(sk, index) in currentEval.saven_test.soft_skills_data_with_titles" :key="index" :index="index">
                    <div class="skill_title" v-if="sk.title">
                        <h3 class="dim_cat_title">{{ sk.title[$i18n.locale] }}</h3>
                    </div>
                    <div class="skills_scores_container container">
                        <div class="skills_score_item" v-for="(sk, index) in sk.skills" :key="index" :index="index">
                            <SkillScore 
                                :score="sk.score" 
                                :refScore="sk.ref_score" 
                                :scoreDelay="index + 0.2" 
                                :scoreDecal="index + 0.2" 
                                :scoreLabel="sk.name[$i18n.locale]" 
                                :scoreDef="sk.definition[$i18n.locale]" 
                                :class="{ui_hide_ref: !dimensionsPlan.soft_skills_settings.ui_show_ref}" />
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>

</template>

<script>
    import AnimatedNumber from "animated-number-vue";
    import SkillScore from "../scores/skillScore";

    export default {
        name: 'SkillsTab',
        components: {
            AnimatedNumber,
            SkillScore
        },
        mounted() {
            setTimeout(() => {
                this.localMatching = this.matching
            }, 500)
            this.intervalid1 = setInterval(() => {
                if(this.localFiability != this.fiability){this.localFiability = this.localFiability + 1}
            }, 150);
        },
        data(){
            return {
                localMatching: 0,
                localFiability: 0,
                matchingRange: 'low',
            }
        },
        computed: {
            currentEval(){
                return this.$store.state.EvalStore.currentEval
            },
            fiability(){
                return this.currentEval.saven_test.validity_score
            },
            matching(){

                return this.currentEval.saven_test.soft_skills_matching
                return this.currentEval.saven_test.matching_score
            },
            dimensionsPlan(){
                return this.$store.state.EvalStore.currentEval.saven_test.dimensions_plan
            }
        },
        methods: {
            formatValue(val){
                    if(val < 25){this.matchingRange = 'low'}
                    if(val >= 25 && val < 40){this.matchingRange = 'middleLow'}
                    if(val >= 40 && val < 60){this.matchingRange = 'middle'}
                    if(val >= 60 && val < 75){this.matchingRange = 'middleHigh'}
                    if(val >= 75){this.matchingRange = 'high'}
                return val.toFixed(0)
            },
            starIsChecked(val){
                return this.localFiability >= val
            }
        }
    }
</script>

<style lang="scss" scoped>
#skills_tab{
    .skills_scores_panel_container{
        padding-top: 60px;
        background: $white;
        .skill_title{
            display: flex;
            justify-content: center;
            align-items: center;
            .dim_cat_title {
                color: #8f9aaa;
                font-size: 1.5rem;
                font-weight: 600;
                margin-top: 12px;
                margin-bottom: 12px;
                text-align: left;
                text-transform: uppercase;
            }
        }
        .skills_scores_container{
            margin: 0px auto 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            .skills_score_item{
                padding: 20px;
                width: calc(100% / 3);
                min-width: 280px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
}
.radial_scores_line{
    background: #f5f5f5;
    border-bottom: 1px solid #0000000f;
    border-top: 1px solid #0000000f;
    .radial_scores_container{
        padding: 20px 0;
        display: flex;
        justify-content: center;
        padding-right: 150px;
        .radial_score{
            display: flex;
            align-items: center;
            .radial_label{
                width: 145px;
                text-align: right;
                font-weight: 500;
            }
        }
    }
}

.matching_bar_container{
    transition: .3s all;
    &.low{
        background: $score-diff5;
    }
    &.middleLow{
        background: $score-diff4;
    }
    &.middle{
        background: $score-diff3;
    }
    &.middleHigh{
        background: $score-diff2;
    }
    &.high{
        background: $score-diff1;
    }
    .matching_bar{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0;
        .matching_label_container{
            .matching_title{
                color: white;
                font-size: 1.5rem;
                font-weight: 600;

            }
        }
        .matching_container{
            max-width: 200px;
            height: 90px;
            margin-left: auto;
            .matching_number{
                font-size: 7rem;
                font-weight: 800;
                letter-spacing: -4px;
                margin-top: -28px;
                transition: .3s all;
                color: white;
            }
        }
        .fiability_container{
            max-width: 200px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 0;
            margin-left: auto;
            .fiability_label{
                font-weight: 500;
                color: white;
                margin-right: 12px;
                font-size: 1.25rem;
            }
            .fiability_score{
                .zmdi{
                    font-size: 1.5rem;
                    transition: .3s all;
                    color: white;
                    opacity: .5;
                    &.active{
                        opacity: 1;
                    }
                }
            }
        }
    }
}

</style>